import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import FormHelperText from '@material-ui/core/FormHelperText';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import DeleteIcon from '@material-ui/icons/Delete';
import Typography from '@material-ui/core/Typography';
import InputAdornment from '@material-ui/core/InputAdornment';

import FormContainer from '../../common-components/FormContainer';
import Page from '../../common-components/Page';
import AyncLoading from '../../common-components/AyncLoading';
import FlexOne from '../../common-components/FlexOne';
import ComfirmDialog from '../../common-components/ComfirmDialog';
import AlertDialog from '../../common-components/AlertDialog';

import * as stationsReducer from '../reducer';
import * as stationScreenReducer from '../reducer/stationScreen';
import * as systemReducers from '../../system/reducer';

import * as stationScreenActionMgr from '../action-mgr/stationScreen';
import * as stationsActionMgr from '../action-mgr';

import { stationStatus } from '../constants';
import * as strings from '../../helpers/strings';
import { mapMarkerIcon } from '../../helpers/constants';

const styles = {
  map: {
    width: "100%",
    height: 350,
    backgroundColor: "grey"
  },
  mapSearchBox: {
    backgroundColor: "#fff",
    fontSize: 15,
    fontWeight: 300,
    marginLeft: 12,
    padding: "0 11px 0 13px",
    textOverflow: "ellipsis",
    width: 400
  }
}

class StationScreen extends Component {

  constructor() {
    super();

    this.handleNameChange = this.handleNameChange.bind(this);
    this.handleProjectNameChange = this.handleProjectNameChange.bind(this);
    this.handleRefSlowDataFileChange = this.handleRefSlowDataFileChange.bind(this);
    this.handleRefCapacityDataFileChange = this.handleRefCapacityDataFileChange.bind(this);
    this.handleRefFastDataFileChange = this.handleRefFastDataFileChange.bind(this);
    this.handleDescriptionChange = this.handleDescriptionChange.bind(this);
    this.handleLocationChange = this.handleLocationChange.bind(this);
    this.handleCountryChange = this.handleCountryChange.bind(this);
    this.handleCityChange = this.handleCityChange.bind(this);
    this.handleLongitudeChange = this.handleLongitudeChange.bind(this);
    this.handleLatitudeChange = this.handleLatitudeChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleArchive = this.handleArchive.bind(this);
    this.handleConfirmArchive = this.handleConfirmArchive.bind(this);
    this.handleRestore = this.handleRestore.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.handleDeleteRefFastDataFile = this.handleDeleteRefFastDataFile.bind(this);
    this.handleDeleteRefCapacityDataFile = this.handleDeleteRefCapacityDataFile.bind(this);
    this.handleDeleteRefSlowDataFile = this.handleDeleteRefSlowDataFile.bind(this);
    this.placeMarkerAndPanTo = this.placeMarkerAndPanTo.bind(this);
    this.renderMap = this.renderMap.bind(this);
  }

  componentDidMount() {
    const { resetActionStatus } = this.props
    resetActionStatus();
    this.renderMap();
  }

  componentDidUpdate() {
    const { actionStatus, } = this.props;
    if (actionStatus === true) {
      this.props.history.push("/stations")
    }
  }

  componentWillUnmount() {
    window.stationMarker = null;
  }

  handleNameChange(e) {
    this.props.setName(`Stn${e.target.value.replace('Stn','')}`);
  }

  handleProjectNameChange(e) {
    this.props.setProjectName(e.target.value);
  }

  handleRefSlowDataFileChange(e) {
    this.props.setRefSlowDataFile(e.target.files[0]);
  }

  handleRefCapacityDataFileChange(e) {
    this.props.setRefCapacityDataFile(e.target.files[0]);
  }

  handleRefFastDataFileChange(e) {
    this.props.setRefFastDataFile(e.target.files[0]);
  }

  handleDescriptionChange(e) {
    this.props.setDescription(e.target.value);
  }

  handleLocationChange(e) {
    this.props.setLocation(e.target.value);
  }

  handleCountryChange(e) {
    this.props.setCountry(e.target.value);
  }
  
  handleCityChange(e) {
    this.props.setCity(e.target.value);
  }

  handleLongitudeChange(e) {
    this.props.setLongitude(e.target.value);
  }

  handleLatitudeChange(e) {
    this.props.setLatitude(e.target.value);
  }

  handleDeleteRefFastDataFile() {
    this.props.setRefFastDataFile("");
    document.getElementById("contained-button-fast").value = '';
  }

  handleDeleteRefCapacityDataFile() {
    this.props.setRefCapacityDataFile("");
    document.getElementById("contained-button-capacity").value = '';
  }

  handleDeleteRefSlowDataFile() {
    this.props.setRefSlowDataFile("");
    document.getElementById("refSlowData").value = '';
  }

  handleSave() {
    const { createStation, updateStation, station, graphReferences } = this.props;
    if (station.id)
      updateStation(station, graphReferences);
    else
      createStation(station, graphReferences);
  }

  handleArchive() {
    this.props.toggleDisabledConfirmation();
  }

  handleConfirmArchive() {
    const { station, archiveStation } = this.props;
    archiveStation(station.id);
  }

  handleRestore() {
    const { station, restoreStation } = this.props;
    restoreStation(station.id);
  }

  handleBack() {
    this.props.history.push("/stations");
  }

  handleRemoveGraphReference = index => e => {
    this.props.removeGraphReference(index);
  }

  placeMarkerAndPanTo(latLng, map) {
    const { setLatitude, setLongitude } = this.props;
    setLatitude(latLng.lat());
    setLongitude(latLng.lng());

    var marker = window.stationMarker;
    if (marker) {
      marker.setPosition(latLng);
    } else {
      marker = new window.google.maps.Marker({
        position: latLng,
        map,
        icon: mapMarkerIcon
      });
      window.stationMarker = marker;
    }
    map.panTo(latLng);
  }
  
  renderMap() {
    const {
      station,
      setLocation,
      setLongitude,
      setLatitude,
      setCountry,
      setCity
    } = this.props;
  
    let position = {};
    if (station.id) {
      position.lat = station.latitude;
      position.lng = station.longitude;
    } else {
      position.lat = 1.214649;
      position.lng = 103.844269;
    }
  
    const GoogleMaps = window.google.maps;
    const map = new GoogleMaps.Map(document.getElementById(strings.idMapStations), {
      zoom: 10,
      center: position
    });
  
    const input = document.getElementById(strings.idMapSearchBox);
    const searchBox = new GoogleMaps.places.SearchBox(input);
    map.controls[GoogleMaps.ControlPosition.TOP_LEFT].push(input);
  
    map.addListener('bounds_changed', () => {
      searchBox.setBounds(map.getBounds());
    });
  
    searchBox.addListener('places_changed', () => {
      const places = searchBox.getPlaces();
      if (places.length === 0) return;
  
      const place = places[0];
      const latLng = place.geometry.location;
  
      setLocation(place.formatted_address);
      setLatitude(latLng.lat());
      setLongitude(latLng.lng());
  
      // Extract country and city from address components
      const components = place.address_components || [];
      let country = "";
      let city = "";
  
      components.forEach(component => {
        if (component.types.includes("country")) {
          country = component.long_name;
        }
        if (
          component.types.includes("locality") ||
          component.types.includes("administrative_area_level_1")
        ) {
          city = component.long_name;
        }
      });
  
      if (country) {
        console.log("Auto-detected country:", country);
        setCountry(country);
      }
  
      if (city) {
        console.log("Auto-detected city:", city);
        setCity(city);
      }
  
      // Place marker
      const marker = window.stationMarker;
      if (marker) {
        marker.setPosition(latLng);
      } else {
        window.stationMarker = new GoogleMaps.Marker({
          position: latLng,
          map,
          icon: mapMarkerIcon
        });
      }
  
      // Fit map to bounds
      const bounds = new GoogleMaps.LatLngBounds();
      if (place.geometry.viewport) {
        bounds.union(place.geometry.viewport);
      } else {
        bounds.extend(latLng);
      }
      map.fitBounds(bounds);
    });
  
    // Place marker if editing
    if (station.id) {
      window.stationMarker = new GoogleMaps.Marker({
        position,
        map,
        icon: mapMarkerIcon
      });
    }
  
    const fun = this.placeMarkerAndPanTo;
    map.addListener('click', function (e) {
      fun(e.latLng, map);
    });
  }

  render() {
    const { station, isValid, isSavingStation, isArchiving, isRestoring, snackBarMessage, openDisabledConfirmation, toggleDisabledConfirmation, graphColors, isAlertDialogOpened, toggleAlertDialog, openedSnackBar, closeSnackBar, classes } = this.props;

    var isInAyncProcess = isSavingStation || isArchiving || isRestoring;

    let fields = [];
    if (graphColors) {
      for (var key in graphColors) {
        fields.push(key);
      }
    }

    var asyncLoadingMessage = "";
    if (isSavingStation)
      asyncLoadingMessage = strings.lblSaving;
    if (isArchiving)
      asyncLoadingMessage = strings.lblArchiving;
    if (isRestoring)
      asyncLoadingMessage = strings.lblRestoring;

    console.log(station)

    return (
      <Page title={station.id ? strings.lblEditStation : strings.lblNewStation}>
        <Snackbar
          anchorOrigin={{
            vertical: "top",
            horizontal: "right"
          }}
          open={openedSnackBar}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          message={<span id="message-id">{snackBarMessage}</span>}
          action={[
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              onClick={closeSnackBar}
            >
              <CloseIcon />
            </IconButton>
          ]}
        />
        {isInAyncProcess && <AyncLoading message={asyncLoadingMessage} />}
        <Paper style={{ padding: 10 }}>
          <FormContainer>
            <Typography variant="h6">{strings.lblStationInformation}</Typography><br />
            <Grid container spacing={16}>
              <Grid item md={4} sm={6} xs={12}>

                <TextField
                  label="Station Name"
                  id="outlined-start-adornment"
                  fullWidth={true}
                  value={station.name.replace('Stn','')}
                  onChange={this.handleNameChange}
                  InputProps={{
                    startAdornment: <InputAdornment position="start">Stn</InputAdornment>,
                  }}
                  variant={strings.txtOutlined}
                  disabled={!!station.id}
                  required
                />
              </Grid>
              <Grid item md={4} sm={12} xs={12}>
                <TextField
                  label={strings.lblDescription}
                  value={station.description}
                  fullWidth={true}
                  onChange={this.handleDescriptionChange}
                  variant={strings.txtOutlined}
                />
              </Grid>
              <Grid item md={4} sm={12} xs={12}>
                <TextField
                  label={strings.lblProjectName}
                  value={station.projectName}
                  fullWidth={true}
                  onChange={this.handleProjectNameChange}
                  variant={strings.txtOutlined}
                  required
                />
              </Grid>
              <Grid item md={4} sm={12} xs={12}>
                <TextField
                  label={strings.lblLocation}
                  value={station.location}
                  fullWidth={true}
                  onChange={this.handleLocationChange}
                  variant={strings.txtOutlined}
                />
              </Grid>
              <Grid item md={4} sm={12} xs={12}>
                <TextField
                  label={strings.lblCountry}
                  value={station.country}
                  fullWidth={true}
                  onChange={this.handleCountryChange}
                  variant={strings.txtOutlined}
                  required
                />
              </Grid>

              <Grid item md={4} sm={12} xs={12}>
                <TextField
                  label={strings.lblCity}
                  value={station.city}
                  fullWidth={true}
                  onChange={this.handleCityChange}
                  variant={strings.txtOutlined}
                  required
                />
              </Grid>

            </Grid><br />
            <label>Search and set the station location on the map search box — location, country, and city will auto-fill.</label>
            <input id={strings.idMapSearchBox} className={classes.mapSearchBox} placeholder={strings.placeholderSearch} />
            <div id={strings.idMapStations} className={classes.map} />
            <br /><FormHelperText>{strings.lblAsteriskRequired}</FormHelperText><br />
            <Divider /><br />
            {(!station.id) ? <Typography variant="h6">{strings.lblSlowDataGraphReference}</Typography> : ''}
            <Grid container spacing={16} alignItems="center">
              {/* File Input Field */}
              <Grid item md={4} sm={6} xs={12}>
                <InputLabel ref={ref => { this.InputLabelRef = ref; }} htmlFor={strings.idRefSlowData}>{strings.lblReferenceForSlowData}</InputLabel>
                <Typography>File Name: {(station.refslowdatajson === undefined || station.refslowdatajson === "") ? "No File" : station.refslowdatajson.name}</Typography>
                <FormControl variant={strings.txtOutlined} fullWidth={true}>
                  <input
                    accept="application/json"
                    className={classes.input}
                    style={{ display: 'none' }}
                    id={strings.idRefSlowData}
                    multiple
                    type="file"
                    onChange={this.handleRefSlowDataFileChange}
                  />
                  <Grid item container>
                    <Grid item xs={6}>
                      <label htmlFor={strings.idRefSlowData}>
                        <Button variant="contained" component="span" className={classes.button} color={strings.colorPrimary} >
                          Upload
                    </Button>
                      </label>
                    </Grid>
                    <Grid item xs={6}>
                      <Button
                        variant="contained"
                        color={strings.colorSecondary}
                        onClick={this.handleDeleteRefSlowDataFile}
                        className={classes.button}
                        starticon={<DeleteIcon />}
                      >
                        Delete
                  </Button>
                    </Grid>
                  </Grid>
                </FormControl>
              </Grid>
              <Grid item md={4} sm={6} xs={12}>
                <InputLabel ref={ref => { this.InputLabelRef = ref; }} htmlFor={strings.idRefCapacityData}>{strings.lblReferenceForCapacityData}</InputLabel>
                <Typography>File Name: {(station.refcapacitydatajson === undefined || station.refcapacitydatajson === "") ? "No File" : station.refcapacitydatajson.name}</Typography>
                <FormControl variant={strings.txtOutlined} fullWidth={true}>
                  <input
                    accept="application/json"
                    className={classes.input}
                    style={{ display: 'none' }}
                    id="contained-button-capacity"
                    multiple
                    type="file"
                    onChange={this.handleRefCapacityDataFileChange}
                  />
                  <Grid item container>
                    <Grid item xs={6}>
                      <label htmlFor="contained-button-capacity">
                        <Button variant="contained" component="span" className={classes.button} color={strings.colorPrimary}>
                          Upload
                    </Button>
                      </label>
                    </Grid>
                    <Grid item xs={6}>
                      <Button
                        variant="contained"
                        color={strings.colorSecondary}
                        onClick={this.handleDeleteRefCapacityDataFile}
                        className={classes.button}
                        starticon={<DeleteIcon />}
                      >
                        Delete
                  </Button>
                    </Grid>
                  </Grid>
                </FormControl>
              </Grid>
              <Grid item md={4} sm={6} xs={12}>
                <InputLabel ref={ref => { this.InputLabelRef = ref; }} htmlFor={strings.idRefFastData}>{strings.lblReferenceForFastData}</InputLabel>
                <Typography>File Name: {(station.reffastdatajson === undefined || station.reffastdatajson === "") ? "No File" : station.reffastdatajson.name}</Typography>
                <FormControl variant={strings.txtOutlined} fullWidth={true}>
                  <input
                    accept="application/json"
                    className={classes.input}
                    style={{ display: 'none' }}
                    id="contained-button-fast"
                    type="file"
                    onChange={this.handleRefFastDataFileChange}
                  />
                  <Grid item container>
                    <Grid item xs={6}>
                      <label htmlFor="contained-button-fast">
                        <Button variant="contained" component="span" className={classes.button} color={strings.colorPrimary}>
                          Upload
                    </Button>
                      </label>
                    </Grid>
                    <Grid item xs={6}>
                      <Button
                        variant="contained"
                        color={strings.colorSecondary}
                        onClick={this.handleDeleteRefFastDataFile}
                        className={classes.button}
                        starticon={<DeleteIcon />}
                      >
                        Delete
                  </Button>
                    </Grid>
                  </Grid>
                </FormControl>
              </Grid>
            </Grid>
            <br />
            <Divider />
            <br />
            <Grid container>
              <Button
                variant={strings.btnRaised}
                disabled={isInAyncProcess}
                onClick={this.handleBack}
              >
                {strings.lblBack}
              </Button>
              <FlexOne />
              {station.id && station.status === stationStatus.archived &&
                <Button color={strings.colorSecondary} variant={strings.btnRaised} onClick={this.handleRestore} >{strings.lblRestore}</Button>
              }
              &nbsp;
              {station.id && station.status === stationStatus.active &&
                <Button color={strings.colorSecondary}
                  variant={strings.btnRaised}
                  onClick={this.handleArchive}
                >
                  {strings.lblArchive}
                </Button>
              }
              &nbsp;
              <Button
                color={strings.colorPrimary}
                variant={strings.btnRaised}
                disabled={!isValid || isInAyncProcess}
                onClick={this.handleSave}
              >
                {strings.lblSave}
              </Button>
            </Grid>
          </FormContainer>
        </Paper>
        <AlertDialog
          title={strings.lblInformation}
          message={strings.msgCannotAddExistingField}
          open={isAlertDialogOpened}
          onClose={toggleAlertDialog}
        />
        <ComfirmDialog
          title={station.name}
          message={strings.msgDisabledConfirm}
          onCancel={toggleDisabledConfirmation}
          onOK={this.handleConfirmArchive}
          btnCancelText={strings.lblCancel}
          btnOKText={strings.lblArchive}
          open={openDisabledConfirmation}
        />
      </Page>
    )
  }
}

const mapStateToProps = state => ({
  station: stationScreenReducer.getStation(state),
  idError: stationScreenReducer.getIdError(state),
  isValid: stationScreenReducer.getIsValid(state),
  isSavingStation: stationsReducer.getIsSaving(state),
  isRestoring: stationsReducer.getIsRestoring(state),
  isArchiving: stationsReducer.getIsArchiving(state),
  snackBarMessage: stationScreenReducer.getSnackBarMessage(state),
  openDisabledConfirmation: stationScreenReducer.getOpenDisabledConfirmation(state),
  graphReferences: stationScreenReducer.getGraphReferences(state),
  selectedFieldName: stationScreenReducer.getSelectedFieldName(state),
  selectedAgg: stationScreenReducer.getSelectedAgg(state),
  openedSnackBar: stationScreenReducer.getOpenedSnackBar(state),
  graphColors: systemReducers.getGraphColors(state),
  actionStatus: stationScreenReducer.getActionStatus(state),
  isAlertDialogOpened: stationScreenReducer.getIsAlertDialogOpened(state)
})

const mapActionsToProps = {
  ...stationScreenActionMgr,
  createStation: stationsActionMgr.create,
  updateStation: stationsActionMgr.update,
  archiveStation: stationsActionMgr.archive,
  restoreStation: stationsActionMgr.restore,
  closeSnackBar: stationScreenActionMgr.closeSnackBar,
}

export default connect(mapStateToProps, mapActionsToProps)(
  withRouter(
    withStyles(styles)(StationScreen)
  )
);